module.exports = __webpack_public_path__ + "static/media/newsletter-1.626c8d79.png";